/**
 * @file: 画布内组件复制、剪切、粘贴
 * @author: xiaolong.huang@dmall.com
 */

import { paste } from './paste';
import { copy } from './copy';
import { cut } from './cut';

export default {
    paste,
    copy,
    cut
}
